import React, { useState, useContext, useEffect } from "react";
import { useDidUpdate } from "../../../../hooks/useUpdate";
import axios from "./../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// Components
import NewFilesConsultantSelect from "../../DashboardReuseAbleComponents/AddNewFiles/NewFilesConsultantSelect";
import Checkbox from "@mui/material/Checkbox";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";

// Styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css";

export default function ConsultantLimitationModal(props) {
  const { userToken, userData } = useContext(UserContext);
  const [consultantLimit, setConsultantLimitedItem] = useState([
    { id: "OwnerDetail", name: "اطلاعات مالک", status: false },
    { id: "ShortAddress", name: "آدرس حدودی", status: false },
    { id: "FullAddress", name: "آدرس دقیق", status: false },
    { id: "EstateInfoFullName", name: "نام مالک", status: false },
    { id: "EstateInfoPhoneNumber", name: "شماره مالک", status: false },
    { id: "EstateInfoResponsibility", name: "نقش مالک", status: false },
  ]);
  const [addedLimitsConsultant, setAddedLimitsConsultant] = useState([]);

  const [limitData, setLimitData] = useState({
    createdBefore: false,
    btnLoader: false,
    openedAccordion: "0",
    fileConsultant: [],
  });

  useEffect(() => {
    const getaddedLimits = async () => {
      if (props.show) {
        if (limitData.fileConsultant[0]?.id) {
          const getLimitFields = await axios.get(
            `ConsultantLimiting/ConsultantLimitFields?consultantId=${limitData.fileConsultant[0].id}&estateId=${props.fileID}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          if (getLimitFields.data.data === null) {
            setLimitData(prev => {
              return { ...prev, createdBefore: false };
            });
          } else if (getLimitFields.data.data.fileItems == "") {
            setLimitData(prev => {
              return { ...prev, createdBefore: true };
            });
          } else if (getLimitFields.data.data.fileItems != "") {
            const limits = getLimitFields.data.data.fileItems;
            setAddedLimitsConsultant(limits);
            setLimitData(prev => {
              return { ...prev, createdBefore: true };
            });
          }
        }
      }
    };
    getaddedLimits();
  }, [props.show, props.id, userToken, limitData.fileConsultant, props.fileID]);

  useDidUpdate(() => {
    setConsultantLimitedItem(prevState =>
      prevState.map(item => {
        const match = addedLimitsConsultant?.find(limit => limit.fieldName === item.id);
        if (match) {
          return { ...item, status: true };
        }
        return item;
      })
    );
  }, [addedLimitsConsultant]);

  return (
    <>
      <style type="text/css">
        {`
            .modal {
                background: #3335;
            }

            .modal-content {
                width: 870px;
                border-radius: 24px;
                min-height: auto !important;
            }

            .modal-header {
                align-items: center !important;
            }

            .accordion-header button::after {
                margin-right: auto;
                margin-left: 0 !important;
            }
        `}
      </style>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered onHide={handleClose}>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>محدودسازی فایل</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey={limitData.openedAccordion}>
            <Accordion.Item eventKey="0">
              <Accordion.Header dir="rtl">انتخاب مشاور</Accordion.Header>
              <Accordion.Body>
                <NewFilesConsultantSelect state={userData} fileData={limitData} setFileData={setLimitData} />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header dir="rtl">انتخاب محدودیت</Accordion.Header>
              <Accordion.Body>
                <div dir="rtl" className="w-100 d-flex align-items-center justify-content-between flex-wrap text-end">
                  {consultantLimit?.map(item => (
                    <div key={item.id} className="d-flex align-items-center justify-content-between mt-2 ms-2 col-3">
                      <div className={`d-flex align-items-center justify-content-start`}>
                        <Checkbox
                          checked={item.status}
                          onClick={() => statusHandler(item.id)}
                          inputProps={{ "aria-label": "controlled" }}
                          size="small"
                          name="heldOn"
                        />

                        <div className={ModalStyles.limit_item}>{item.name}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center align-items-center mb-3">
            <div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.outlined_btn}`} onClick={handleClose}>
              انصراف
            </div>

            {limitData.btnLoader ? (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`}>
                <div className={ModalStyles.btn_loader_container}>
                  <div className={ModalStyles.btn_spinner}></div>
                </div>
              </div>
            ) : (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={consultantPostCheckHandler}>
                ثبت
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  function handleClose() {
    props.onHide();
    setLimitData(prev => {
      return {
        ...prev,
        createdBefore: false,
        btnLoader: false,
        openedAccordion: "0",
        fileConsultant: [],
      };
    });
    const updatedData = consultantLimit.map(item => ({
      ...item,
      status: false,
    }));
    setConsultantLimitedItem(updatedData);
    setAddedLimitsConsultant();
  }

  async function statusHandler(id) {
    if (limitData.fileConsultant[0]?.id) {
      const itemSelected = consultantLimit.find(item => id === item.id);
      const newState = consultantLimit.map(obj => {
        if (obj.id === id) {
          return { ...obj, status: !itemSelected.status };
        }
        return obj;
      });
      setConsultantLimitedItem(newState);
      if (limitData.createdBefore) {
        if (!itemSelected.status) {
          try {
            var dataConsultant = new FormData();
            dataConsultant.append("EstateId", props.fileID);
            dataConsultant.append("ConsultantId", limitData.fileConsultant[0].id);
            dataConsultant.append("FieldName", itemSelected.id);

            const addLimitConsultantStatus = await axios.post("ConsultantLimiting/AddFieldToConsultantLimiting", dataConsultant, {
              headers: { authorization: "Bearer " + userToken },
            });
          } catch (error) {
            notify("خطای سرور", "error");
          }
        } else if (itemSelected.status) {
          try {
            var deleteDataConsultant = new FormData();
            deleteDataConsultant.append("FildName", itemSelected.id);
            deleteDataConsultant.append("EstateId", props.fileID);
            deleteDataConsultant.append("consultantId", limitData.fileConsultant[0].id);

            const deleteLimitConsultant = await axios.delete("ConsultantLimiting/RemoveConsultantLimitingField", {
              data: deleteDataConsultant,
              headers: { authorization: "Bearer " + userToken },
            });
            // console.log(deleteLimitConsultant);
          } catch (error) {
            notify("خطای سرور", "error");
            // console.log(error);
          }
        }
      }
    } else {
      notify("ابتدا مشاور را انتخاب کنید", "error");
    }
  }

  function consultantPostCheckHandler() {
    if (limitData.fileConsultant[0]?.id) {
      const allFalse = consultantLimit.every(item => item.status === false);
      if (allFalse) {
        handleClose();
      } else if (!allFalse) {
        postLimitHandlerConsultant();
      }
    } else {
      notify("ابتدا مشاور را انتخاب کنید", "error");
    }
  }

  async function postLimitHandlerConsultant() {
    if (limitData.createdBefore === false) {
      try {
        setLimitData(prev => {
          return { ...prev, btnLoader: true };
        });
        const newSelectLimit = consultantLimit?.filter(item => {
          if (item.status) {
            return item;
          }
        });
        var consultantData = new FormData();
        consultantData.append("ConsultantId", limitData.fileConsultant[0].id);
        consultantData.append("EstateId", props.fileID);
        for (const items of newSelectLimit) {
          consultantData.append("FieldNames", items.id);
        }

        const addLimitConsultant = await axios.post("ConsultantLimiting", consultantData, {
          headers: { authorization: "Bearer " + userToken },
        });
        // console.log(addLimitConsultant);
        if (addLimitConsultant.data.isSuccess) {
          notify("درحال اعمال محدودیت", "success");
          handleClose();
        } else {
          handleClose();
        }
        notify("خطای سرور", "error");
      } catch (error) {
        notify("خطای سرور", "error");
        props.onHide();
        setLimitData(prev => {
          return {
            ...prev,
            createdBefore: false,
            btnLoader: false,
            openedAccordion: "0",
            fileConsultant: [],
          };
        });
        const updatedData = consultantLimit.map(item => ({
          ...item,
          status: false,
        }));
        setConsultantLimitedItem(updatedData);
        setAddedLimitsConsultant(null);
      }
    } else {
      handleClose();
    }
  }
}
